// extracted by mini-css-extract-plugin
export default {"centeredFallback":"CenteredFallback_centeredFallback__1b0KM"};